module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="image-container">\n    <img src="' +
__e( absoluteThumbUrl ) +
'" />\n</div>\n<div class="image-name editable-container">\n    <div contenteditable="' +
__e( editable ) +
'" class="editable edit-name';
 if (!editable) { ;
__p += ' disabled';
 } ;
__p += '" ';
 if (!editable)
        { ;
__p += 'disabled\n        ';
 } ;
__p += '>\n    </div>\n</div>\n<div class="details">\n    <div class="js-alt-text-editable-container editable-container';
 if (!editable) { ;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="alt-text-label">Alt text:&nbsp;</div>\n        <div class="js-alt-text alt-text editable" contenteditable="' +
__e( editable ) +
'"></div>\n        ';
 if (editable) { ;
__p += '\n            <div class="editable-cell-img js-alt-text-icon">\n                <div class="editable-img"></div>\n            </div>\n        ';
 } ;
__p += '\n    </div>\n    <ul>\n        <li>Size: <i>' +
__e( width ) +
' &times; ' +
__e( height ) +
' / ' +
__e( displaySize ) +
'</i></li>\n        <li>Type: <i>' +
__e( extension ) +
'</i></li>\n        <li>Times used: <i>' +
__e( timesUsed ) +
'</i></li>\n    </ul>\n</div>\n<div class="image-experiences">\n    ';
 if (experienceCount > 0) { ;
__p += '\n        <button class="btn btn-link toggle-experiences-button collapsible ' +
__e( showExperiences ? "open" : "" ) +
'" data-toggle="collapse" data-target=".image-experiences-collection-region">\n            Used in ' +
__e( experienceCount ) +
' experience' +
__e( experienceCount > 1 ? "s" : "" ) +
'</span>\n        </button>\n    ';
 } else { ;
__p += '\n        <i class="no-experiences">The image is currently not used</i>\n    ';
 } ;
__p += '\n    <div class="image-experiences-collection-region ' +
__e( showExperiences ? "" : "collapse" ) +
'"></div>\n</div>\n';
 if (showTags) { ;
__p += '\n    <div class="tags">\n        <div class="tags-collection-region"></div>\n    </div>\n';
 } ;
__p += '\n';
 if (showInventory) { ;
__p += '\n<div class="inventory">\n    <div class="inventory-collection-region"></div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/imageLibrary/ImageDetailsView.tpl
// module id = 2858
// module chunks = 0